import React from 'react';

import { getPersistor } from '@rematch/persist';
import { Button } from 'components/Button';
import { Card } from 'components/Container';

interface IErrorScreen {
	message?: string;
}

export const ErrorScreen = (props: IErrorScreen) => {
	const { message } = props;

	const _reload = () => {
		window.location.reload();
	};

	// Last resort if the persisted state itself is broken: drop it and start fresh.
	// The token stays in the URL, so the user is logged in again after the reload.
	const _resetAndReload = async () => {
		try {
			await getPersistor().purge();
		} catch (error) {
			console.log('resetAndReload', error);
		}
		window.location.reload();
	};

	return (
		<Card hatColor="text-danger-500">
			<div className="text-danger-500 font-bold text-lg md:text-2xl text-center mb-4">Something went wrong</div>
			<div className="text-white text-center mb-6 px-4">{message ?? 'An unexpected error occurred. Please reload the page.'}</div>
			<div className="flex flex-col self-center items-center mb-6">
				<Button title="Reload" type="warning" onClick={_reload} />
				<div className="cursor-pointer underline text-sm text-warning-500 mt-4" onClick={_resetAndReload}>
					Still not working? Reset app data and reload
				</div>
			</div>
		</Card>
	);
};
